import React from 'react';
import { CheckIcon, PickaxeIcon } from 'lucide-react';
import { Button } from './ui/Button';
import { Countdown } from './ui/Countdown';
import { checkoutUrl, price, priceBefore, productShortName, totalBonuses, totalVolumes } from '../data/offer';
const assurances = ['Garantía de 7 días', 'Pago seguro', 'Acceso inmediato', 'Material listo para usar desde hoy'];
export function FinalCta() {
  return <section className="field-grid bg-forest-950 py-16 sm:py-20" aria-labelledby="final-title" data-id="element-77" data-mp="1jcd5md9gm4dl">
      <div className="mx-auto max-w-3xl px-4 text-center" data-id="element-78" data-mp="1eetqzc8unpl4">
        <p className="inline-flex items-center gap-2 text-xs font-extrabold uppercase tracking-[.16em] text-gold-300" data-id="element-79" data-mp="1ec7jtdpvfc3f">
          <PickaxeIcon className="h-4 w-4" aria-hidden="true" data-id="element-80" data-mp="1o43mz36tdsei" /> {productShortName}
        </p>
        <h2 id="final-title" className="mx-auto mt-5 max-w-2xl text-balance text-3xl font-extrabold text-cream sm:text-4xl" data-id="element-81" data-mp="223d0fv3my8es">
          Hecho por especialistas, para docentes de Latinoamérica.
        </h2>

        <Countdown light className="mt-8" data-id="element-82" data-mp="n5uma2yndpha" />

        <div className="mt-8 flex flex-col gap-5 rounded-xl border-2 border-gold-500 bg-cream p-6 text-left shadow-2xl shadow-black/30 sm:flex-row sm:items-center sm:justify-between" data-id="element-83" data-mp="n75ovzgcwr6t">
          <p data-id="element-84" data-mp="x2z821okzixk">
            <b className="block font-display text-base leading-tight tracking-tight text-forest-950" data-id="element-85" data-mp="x27eewejnv9x">{productShortName}</b>
            <span className="text-sm text-earth-700" data-id="element-86" data-mp="120ilx0hd9toz">
              {totalVolumes} tomos + {totalBonuses} bonos · Acceso inmediato
            </span>
          </p>
          <div className="shrink-0 sm:text-right" data-id="element-87" data-mp="1b28ngz4yq90h">
            <p className="text-sm text-earth-700" data-id="element-88" data-mp="1fu9zql24rzqi">
              <span className="mr-2 line-through" data-id="element-89" data-mp="1fus27zfdza6v">{priceBefore}</span>
              <b className="text-lg text-forest-900" data-id="element-90" data-mp="1ktmhire5agm8">{price}</b>
            </p>
            <Button href={checkoutUrl} target="_blank" rel="noopener noreferrer" size="sm" className="mt-2" data-id="element-91" data-mp="1pspo4g9rwuwb">
              Quiero mi Megapack ahora
            </Button>
          </div>
        </div>

        <ul className="mt-8 flex flex-wrap justify-center gap-x-5 gap-y-2 text-xs font-semibold text-forest-100" data-id="element-92" data-mp="3qufgxynvg0wd">
          {assurances.map(item => <li key={item} className="inline-flex items-center gap-1.5" data-id="element-93" data-mp="3lx5khz22eoz1">
              <CheckIcon className="h-4 w-4 text-gold-400" aria-hidden="true" data-id="element-94" data-mp="3imuaepzqzct" /> {item}
            </li>)}
        </ul>
      </div>
    </section>;
}